/**
 * 数据变更重新赋值
 */
import * as types from './mutation-types.js';

const mutations = {
  [types.SET_MENU_LIST] (state, data) {
    state.menuList = data;
  },
  [types.SET_SHEET_VISIBLE] (state, flag) {
    state.sheetVisible = flag;
  },
    [types.SET_AUTHORITIES] (state, flag) {
        state.authorities = flag;
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js